import { _baseGetFetch, _basePostFetch, _basePutFetch, _baseDeleteFetch, ApiEnum } from './baseFetch'
const videoUploadsLimit = 20

export const getVideosCategories = () => {
  return _baseGetFetch(`/videos/categories`)
}

export const getVideosLanguages = () => {
  return _baseGetFetch(`/videos/languages`)
}

export const getVideosList = (queryParams) => {
  return _baseGetFetch(`/videos`, queryParams)
}

export const getVideosUpload = async (queryParams) => {
  return _baseGetFetch(`/videos`, { ...queryParams, maxResults: videoUploadsLimit }, ApiEnum.admin)
}

export const getVideosListFavorites = ({ username, ...queryParams }) => {
  return _baseGetFetch(`/users/${username}/videos/favourites`, queryParams)
}

export const putVideoFavourites = (username, video_id, isFav) => {
  return _basePutFetch(`/users/${username}/videos/favourites/${video_id}`, {
    is_favourite: isFav,
  })
}

export const postVideoFavourites = (username, favourite_id, isFav) => {
  return _basePostFetch(`/users/${username}/videos/favourites`, {
    video_id: favourite_id,
    is_favourite: isFav,
  })
}

export const getVideosModels = () => {
  return _baseGetFetch(`/videos/models`)
}

export const postVideo = async (bodyParams) => {
  return _basePostFetch(`/videos`, bodyParams, ApiEnum.admin)
}

export const putVideo = async (videoId, bodyParams) => {
  return _basePutFetch(`/videos/${videoId}`, bodyParams, ApiEnum.admin)
}

export const deleteVideo = async (videoId) => {
  return _baseDeleteFetch(`/videos/${videoId}`, undefined, ApiEnum.admin)
}

export const getAdminVideoCategories = async () => {
  return _baseGetFetch(`/videos/categories`, undefined, ApiEnum.admin)
}

export const getAdminVideoTypes = async () => {
  return _baseGetFetch(`/videos/types`, undefined, ApiEnum.admin)
}

